const styles = () => ({
    tableContainer: {
        minHeight: "54vh",
        maxHeight: "58vh",
        overflow: "auto"
    },
    tableCell: {
        textAlign: "center"
    },
});

export default styles;